import { createPerimeter } from 'vue-kindergarten';
import {isRole} from '../utilities/roleUtilities';

export const PrintersPerimeter = createPerimeter({
    purpose: 'printers',

    can: {
        read () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child)
                || isRole.operator(this.child);
        },

        edit () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child);
        },

        destroy () {
            return isRole.admin(this.child);
        }
    }
});
